import { cn } from "@/lib/utils";
import type { AuthProfileTheme } from "@/lib/authProfileTheme";

interface AuthProfileBannerProps {
  theme: AuthProfileTheme;
  compact?: boolean;
  className?: string;
}

const AuthProfileBanner = ({ theme, compact = false, className }: AuthProfileBannerProps) => {
  const Icon = theme.icon;

  return (
    <div
      className={cn(
        "relative w-full overflow-hidden rounded-xl border",
        theme.cardBorder,
        compact ? "h-28 sm:h-32" : "h-36 sm:h-40",
        className,
      )}
    >
      <img
        src={theme.image}
        alt={theme.imageAlt}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className={cn("absolute inset-0", theme.overlay)} aria-hidden="true" />
      <div className="absolute inset-x-0 bottom-0 flex items-end gap-3 p-4 text-white">
        <div
          className={cn(
            "flex h-11 w-11 shrink-0 items-center justify-center rounded-full shadow-lg",
            theme.iconBadge,
          )}
        >
          <Icon className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="min-w-0 text-left">
          <p className="truncate text-lg font-bold leading-tight drop-shadow-sm">{theme.label}</p>
          <p className="truncate text-xs font-medium text-white/90 drop-shadow-sm">{theme.tagline}</p>
        </div>
      </div>
    </div>
  );
};

export default AuthProfileBanner;
